module.exports = __webpack_public_path__ + "static/media/instagram-logo.fba68d49.svg";